import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as TocaActions from './toca.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class TocaStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new TocaActions.TOCARefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.TOCAS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new TocaActions.TOCACreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new TocaActions.TOCAUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new TocaActions.TOCADelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new TocaActions.TOCARefresh());
      }
    });

  }
}
